import api from './client';

export interface ShipmentsReportFilters {
  mode: 'A' | 'B';
  from: string;   // YYYY-MM-DD
  to: string;     // YYYY-MM-DD
  storeIds?: number[];
  warehouseIds?: string[];
  createdBy?: number[];
  includeVoided?: boolean;
  includeSsShipped?: boolean;
}

function toParams(f: ShipmentsReportFilters): Record<string, string> {
  const p: Record<string, string> = { mode: f.mode, from: f.from, to: f.to };
  if (f.storeIds?.length)     p.storeIds     = f.storeIds.join(',');
  if (f.warehouseIds?.length) p.warehouseIds = f.warehouseIds.join(',');
  if (f.createdBy?.length)    p.createdBy    = f.createdBy.join(',');
  if (f.includeVoided)        p.includeVoided = '1';
  if (f.includeSsShipped)     p.includeSsShipped = '1';
  return p;
}

export const downloadShipmentsReportCSV = async (
  f: ShipmentsReportFilters,
): Promise<void> => {
  const res = await api.get('/reports/shipments', {
    params: { ...toParams(f), format: 'csv' },
    responseType: 'blob',
  });
  const blob = new Blob([res.data], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `shipments-mode-${f.mode}-${f.from}-to-${f.to}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const previewShipmentsReport = (
  f: ShipmentsReportFilters,
): Promise<{ rows: Array<Record<string, unknown>>; count: number }> =>
  api
    .get('/reports/shipments', { params: { ...toParams(f), format: 'json' } })
    .then((r) => r.data);
